import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import moment from 'moment'
import { useState } from 'react'
import { useTranslation } from "react-i18next"

export const YearPicker = ({ year, setYear }) => {
  const { t } = useTranslation()
  const [years, setYears] = useState([
    moment().month() === 11 && moment().add(1, 'year').format('YYYY'),
    moment().format('YYYY'),
    moment().add(-1, 'year').format('YYYY')
  ])

  return (
    <FormControl variant="outlined">
      <InputLabel id="year-label">{t("global.year", "Year")}</InputLabel>
      <Select
        labelId="year-label"
        label={t("global.year", "Year")}
        id="year-select"
        value={moment(year).format('YYYY')}
        onChange={(event) => setYear(event.target.value)}
      >
        {years?.map((yearItem) => (
          <MenuItem key={yearItem} value={yearItem}>
            {yearItem}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
